import { Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { KendoModule } from "src/app/kendo.module";
import { ConnectorZBEQuickActionsSyncSageService } from "./connector-zbe-quickactions-sync-sage.service";
import { CluBeSnackbarService } from "src/app/@clu-be/apps/@services/clube-snackbar.service";
import { STATUS_TASK, STATUS_TASK_LABELS } from "src/app/app.models";
import { TablerIconsModule } from "angular-tabler-icons";

@Component({
    selector: "custom-component",
    templateUrl: 'zbe-quickactions-sync-sage.component.html',
    styleUrls: ['./zbe-quickactions-sync-sage.component.scss'],
    standalone: true,
    imports: [KendoModule, TablerIconsModule],
    providers : [ConnectorZBEQuickActionsSyncSageService, CluBeSnackbarService]
  })
  export class ZBEQuickActionsSyncSageComponent implements OnInit, OnDestroy {
    STATUS_TASK = STATUS_TASK;
    STATUS_TASK_LABELS = STATUS_TASK_LABELS;
    public inputRes : any;
    @Output() public ignore: EventEmitter<undefined> = new EventEmitter();
    
    private timeCounter : any;
    private timeCount : number = 0;
    timeCountF : string = '0:00';

    private timer : any;
    constructor(private connector : ConnectorZBEQuickActionsSyncSageService, private _snackbarService : CluBeSnackbarService) {

    }
    
    ngOnInit(): void {
      this.timer = setInterval(()=> { this.doGetRunnerTaskProgressAction_ZBEQuickActionsSyncSage(); }, 4000);
      this.timeCount++;
      this.timeCounter = setInterval(()=> { this.timeCount++; this.timeCountF = this.formatTimeCountAction_ZBEQuickActionsSyncSage(this.timeCount); }, 1000);
    }

    ngOnDestroy(): void { 
      clearInterval(this.timer); 
      clearInterval(this.timeCounter); 
    }

    public ignoreNotification(event: Event): void {
      event.preventDefault();
      this.ignore.emit();
    }

    doGetRunnerTaskProgressAction_ZBEQuickActionsSyncSage(){
      if(!this.inputRes) return;
      this.connector.doGetRunnerTasksAction_BOAdmSageLink(this.inputRes.ID).subscribe({
        next : (res : any) => {
          if(res && res.mDatas && res.mDatas.length > 0){
            this.inputRes = res.mDatas[0];
            if(this.inputRes && (this.inputRes.STATUS_TASK == STATUS_TASK.TERMINE || this.inputRes.STATUS_TASK == STATUS_TASK.ANNULE || this.inputRes.STATUS_TASK == STATUS_TASK.ECHEC)){ 
              clearInterval(this.timer); clearInterval(this.timeCounter);
              setTimeout(()=> { this.ignore.emit(); }, 10000); 
            }
          }
        }, 
        error : (err : any) => {
            console.error(err);
            if(err.error != undefined && err.error.Message != undefined){ this._snackbarService.displayMessage("ERROR", err.error.Message); }
            else { this._snackbarService.displayMessage("ERROR", "Une erreur est survenue lors de la récupération des infos.."); }
        }
      })

    }

    doCancelRunnerTasksAction_ZBEQuickActionsSyncSage(){
      if(!this.inputRes) return;
      this.connector.doCancelRunnerTasksAction_BOAdmSageLink(this.inputRes.ID).subscribe({
        next : (res : any) => {
          this.doCancelRunnerTasksAction_ZBEQuickActionsSyncSage();
        }, 
        error : (err : any) => {
            console.error(err);
            if(err.error != undefined && err.error.Message != undefined){ this._snackbarService.displayMessage("ERROR", err.error.Message); }
            else { this._snackbarService.displayMessage("ERROR", "Une erreur est survenue lors de l'annulation.."); }
        }
      })

    }

    private formatTimeCountAction_ZBEQuickActionsSyncSage(value: number): string {
      const minutes: number = Math.floor(value / 60);
      return minutes + ':' + (value - minutes * 60).toString().padStart(2, '0');
    }
  }